export const theme = {
  // 设置全局的样式
  token: {},
  // 设置组件的样式
  components: {
    // Menu: {
    //   // 鼠标移入的文本色
    //   colorItemTextHover: '#ff0000',
    //   // 鼠标移入的背景色
    //   colorItemBgHover: '#0000ff',
    //   // 选中的文本色
    //   colorItemTextSelected: '#0000ff',
    //   // 选中的背景色
    //   colorItemBgSelected: '#ff0000'
    // }
  }
};
